let base = window._env_.VUE_APP_ADMIN_HOST
export const getBigDataResult = params => {
  return axios.post(`${base}/data_screen/query_kanban_result`, params)
}



// WEBPACK FOOTER //
// ./src/views/big-data-view/big-data-view.api.js